import axios from "axios";

const API = axios.create({
    timeout: 300000,
    responseType: 'json',
});

export default API;